import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-321a0300")

_pushScopeId("data-v-321a0300")
const _hoisted_1 = { style: {"margin":"5vh 16px"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 提交 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_field = _resolveComponent("van-field")
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_form = _resolveComponent("van-form")

  return (_openBlock(), _createBlock(_component_van_form, {
    onSubmit: _ctx.onSubmit,
    class: "van-form"
  }, {
    default: _withId(() => [
      _createVNode(_component_van_field, {
        modelValue: _ctx.state.cid,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.cid = $event)),
        name: "cid",
        label: "客户CID",
        placeholder: "请填写客户的CID",
        rules: [
        { required: true, message: '请填写客户CID' },
        {
          pattern: /^\d+$/,
          message: '请检查输入的CID格式(不要多出空格)',
          trigger: 'onChange',
        },
      ]
      }, null, 8, ["modelValue", "rules"]),
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_van_button, {
          round: "",
          block: "",
          type: "primary",
          "native-type": "submit",
          "loading-text": "提交中..."
        }, {
          default: _withId(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["onSubmit"]))
})